import template from './calendarContextMenu.html';
import controller from './calendarContextMenu.controller';
import './calendarContextMenu.scss';

let calendarContextMenuComponent = {
  restrict: 'E',
  bindings: {
    onOpenAbsences: '&',
    onEditPeriod: '&',
    isInception: '<',
    isDisabled: '<'
  },
  template,
  controller
};

export default calendarContextMenuComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarContextMenu/calendarContextMenu.component.js